"use client";
import { useCallback } from "react";
import { useTranslations } from "next-intl";

// `t_or(key, fallback)`: the site's translation when its dictionary defines `key`, otherwise `fallback`.
// Lets a core hook show a translated message without breaking sites that have not added the key (they keep the old text).
const useTranslationOr = () => {
  const t = useTranslations();
  return useCallback((key, fallback) => (t.has(key) ? t(key) : fallback), [t]);
};

export default useTranslationOr;
